import React, { useEffect } from 'react';
import { useState } from 'react';
import * as ApiCalls from '../utils/ApiCalls';
import ConsultSimulatorForm from '../components/ConsultSimulatorForm';
import SkuCalculatorResult from '../components/SkuCalculatorResult';

const ConsultSimulatorContainer = () => {
  const [formData, setFormData] = useState({
    age: 30,
    visit_duration: 15,
    diagnosis_cd: '',
    comm_method_cd: 'VIDEO',
    has_rx: false,
    recommended_non_td_service: false,
    brand_cd: '',
    couples_therapy_member_present: false,
    couples_therapy_partner_present: false,
    last_consult_date: null,
    last_consult_same_provider: false
  });

  const { payersLoading, payersError, payers } = ApiCalls.payers();
  const { skusLoading, skusError, skus } = ApiCalls.skus();
  const { callApi, loading, data, error, reset } = ApiCalls.cptCode();
  const [validationErrors, setValidationErrors] = useState({});

  useEffect(() => {
    if (payers.length > 0) {
      setFormData(prevFormData => ({ ...prevFormData, payer_id: payers[0].payerId }));
    }
  }, [payers]);

  useEffect(() => {
    if (skus.length > 0) {
      setFormData(prevFormData => ({ ...prevFormData, sku_cd: skus[0].skuCd }));
    }
  }, [skus]);

  const handleChange = (obj) => {
    if ('target' in obj) {
      const { name, value } = obj.target;
      setFormData(prevFormData => ({ ...prevFormData, [name]: value }));
    }
    else {
      setFormData(prevFormData => ({ ...prevFormData, ...obj }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateFormData()) {
      reset();
      callApi(formData);
    }
  };

  const validateFormData = () => {
    const errors = {};

    const age = parseInt(formData.age, 10);
    if (!age || age <= 0)
      errors.age = 'Age must be a positive number';

    const visitDuration = parseInt(formData.visit_duration, 10);
    if (!visitDuration || visitDuration <= 0)
      errors.visit_duration = 'Visit duration must be a positive number';

    setValidationErrors(errors);

    return Object.keys(errors).length === 0;
  };

  return (
    <div>
      <ConsultSimulatorForm
        payers={payers}
        skus={skus}
        formData={formData}
        loading={loading || payersLoading || skusLoading}
        errors={validationErrors}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
      />
      {payersError && <p className="error">Error fetching payers: {payersError.message}</p>}
      {skusError && <p className="error">Error fetching SKUs: {skusError.message}</p>}
      {error && <p className="error">Error: {error.message}</p>}
      {data && <SkuCalculatorResult data={data} />}
    </div>
  );
}

export default ConsultSimulatorContainer;
